<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <p class="text-center">
        {{ message }}
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogReceiveError",
  setup() {
    const dialogRef = ref(null);
    const message = ref("");

    const openDialog = (err) => {
      message.value = getErrorMessage(err);
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    const getErrorMessage = (err) => {
      switch (err) {
        case "transfer_error_notfound_key":
          return "譲渡用URLが誤っています。";
        case "transfer_error_old_key":
          return "別の譲渡用URLが発行されたため、受け取りできません。購入者から新しいURLをお受け取り下さい。";
        case "transfer_error_same_user":
          return "譲渡元と譲渡先のアカウントが同じであるため、譲渡できません。アカウントをご確認ください。";
        case "transfer_error_used_key":
          return "このチケットは既に受け渡しが完了しているため受け取れません。購入者にご確認ください。";
        case "transfer_error_not_transferable":
          return "このチケットは既に利用または払い戻しされているため受け取りできません。";
        case "internal_server_error":
          return "エラーが発生しました。大変恐れ入りますが、メニューの「お問い合わせ」からご連絡ください。";
        default:
          return "エラーが発生しました。大変恐れ入りますが、メニューの「お問い合わせ」からご連絡ください。";
      }
    };

    return {
      dialogRef,
      message,
      openDialog,
      closeDialog,
    };
  },
};
</script>
